import queryString from 'qs';
import { ftnftAmSetup } from 'config/ftnftAmSetup';
import { kioskSetup } from 'config/kioskSetup';
import { veniceSetup } from 'config/veniceSetup';
import { Configs } from 'constants/app/configs';
import { LANG_MAP } from 'constants/app/lang-map';
import { ViewModes } from 'interfaces';

export const appConfig = () => {
  const { language } = queryString.parse(window.location.search, {
    ignoreQueryPrefix: true
  }) as Record<string, string>;

  if (language) {
    Configs.LANGUAGE_PREFIX = language;
    Configs.LANGUAGE = LANG_MAP[language] || language;
  }

  switch (Configs.VIEW_MODE) {
    case ViewModes.KIOSK:
      kioskSetup();
      break;
    case ViewModes.FTNFT_AM:
      ftnftAmSetup();
      break;
    case ViewModes.KIOSK_AM:
      kioskSetup();
      ftnftAmSetup();
      break;
    case ViewModes.KIOSK_VENICE:
      kioskSetup(15000);
      veniceSetup();
      break;
    default:
      break;
  }
};
